import React, { useState, useEffect } from "react";
import { useTheme } from "../../providers/ThemeProvider";
import { FiSun, FiMoon } from "react-icons/fi";

const ThemeComponent = () => {
  const [mounted, setMounted] = useState(false);
  const { theme, toggleTheme } = useTheme();

  // useEffect only runs on the client, so now we can safely show the UI
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div className="flex mr-3">
      {theme === "dark" ? (
        <FiSun
          onClick={toggleTheme}
          className="cursor-pointer"
          size={26}
          fill="#ffb62e"
          color="#ffb62e"
        />
      ) : (
        <FiMoon
          onClick={toggleTheme}
          className="cursor-pointer"
          size={26}
          fill="#ffb62e"
          color="#ffb62e"
        />
      )}
    </div>
  );
};

export default ThemeComponent;
